import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import useViewPort from "../../../../hook/useViewPort";
import {  Link } from "@quintype/components";
import { CollectionName } from "../../Atoms/CollectionName";
import ImageType4 from "../../../../components/molecules/image-type-4";
import "./one-row-five-cols-rect.m.css";
import { useSelector } from "react-redux";
import { getSlug } from "../../../utils/utils";

const OneRowFiveColsRect = ({ collection, config }) => {
  const bgColor = get(collection, ["associated-metadata", "Type a number from 1-14 for layout background colors"]) || 1;
  const validNumber = bgColor >= 1 && bgColor <= 14 ? bgColor : 1;
  const colorClass = `color-black-${validNumber}`;
  const storiesType = collection.items.filter(itemsStories=>itemsStories.type==="story") || []
  const storiesFromCollectionV2 = storiesType.map(itemsStories=>itemsStories?.story) || []
  const storiesFromCollection = storiesFromCollectionV2;//collectionToStories(collection);//this method is getting episode image from alternate home s3 bucket which is not desired.
  const { viewports } = useViewPort();

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtState, ["currentPath"], "");
  const slug = collection && getSlug(collection, config) || "";

  if (storiesFromCollection.length < 1) {
    return null;
  }

  return (
    <div styleName={`container ${currentPath==="/lammas"? "lammas-padding":""}`}>
      <div styleName="collection-name" className={viewports ? viewports : ""}>
          <CollectionName collection={{
            ...collection,
            name: collection.name.replace(/\s*\(Lammas\)$/, "")
          }} />
          <div styleName="arrow-link-wrapper">
            <Link href={slug} aria-label="collection-name">
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
      </div>
      <div styleName="image-grid" className={viewports ? viewports : ""}>
        {storiesFromCollection.slice(0,20).map((storyItem, index) => {
                  //console.log("imagetype 4 behindPaywall",collectionInfo)
          const accessType = storyItem?.access;
          const paywallIcons = accessType === "login" || accessType === "subscription";

          return (
            <Link
              href={storyItem?.slug}
              id={storyItem?.id}
              styleName="image-container"
              className={viewports ? viewports : ""}
              key={storyItem?.id}
            >
              <ImageType4
                story={storyItem}
                aspectRatio={[[16, 9]]}
                />
                <div
                  style={{ minHeight: "auto"}} styleName="episode-info">
                    <div styleName="headline-icon">
                      <p>{`${storyItem?.headline}`}</p>
                      {paywallIcons && (
                        <img alt="audio-logo" src="/icons/under-subcription.svg" styleName="custom-img-icon" />
                      )}
                    </div>
                </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

OneRowFiveColsRect.propTypes = {
  collection: object,
};

export { OneRowFiveColsRect };

OneRowFiveColsRect.storyLimit = 20;
